/*eslint-disable*/
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  Typography,
  Checkbox,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Icon,
} from "@material-ui/core";
import GridItem from "components/Grid/GridItem.jsx";
import FormCheckbox from "components/Wrappers/materialUIWrappers/components/FormCheckbox.jsx";
import FormDropdown from 'components/Wrappers/materialUIWrappers/components/FormDropDown';
import FormInput from "components/Wrappers/materialUIWrappers/components/FormInput";
import _ from "lodash";
import React, { Fragment } from "react";
import { Field, change } from "redux-form";
import store from "store";
import CustomCardHeading from "../components/CustomCardHeading";
import NumberInput from "components/Wrappers/materialUIWrappers/components/NumberInput";
import { dateValid, isEmptyOrSpaces } from "helpers/ValidationHelpers";
import { ParseDMYwSlashes } from "helpers/DateHelpers";
import GetIdInformation, { idNumberValid } from "helpers/GetIdInformation";
import moment from "moment";
import DescriptiveCell from "../components/DescriptiveCell.jsx";
import "./BuySell.css"

const required = value => (value ? undefined : "Required");
const colwidth = value => {
  return {
    width: value,
    minWidth: value,
    maxWidth: value
  };
};

const CustomFieldMed = props => (
	<GridItem xs={6} sm={6} md={6} style={{ marginTop: '25px' }}>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);

const CustomField2 = props => (
  <GridItem xs={6} sm={6} md={6} style={{ marginTop: '25px' }}>
    <FormControl fullWidth >
      <Field {...props} />
    </FormControl>
  </GridItem>

);

const CustomFieldFullWidth = props => (
	<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '25px' }}>
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	</GridItem>
);

const CustomFieldN = props => (
	
		<FormControl fullWidth>
			<Field {...props} />
		</FormControl>
	
);

const CustomFieldN2 = props => (
	
  <FormControl fullWidth className="rightAlign">
    <Field {...props} />
  </FormControl>

);

const checkItem = (label, name, changeFunc) => {
  return (
    
    <GridItem xs={4} sm={4} md={2} >
            <FormControl style={{marginBottom: "-27px", paddingBottom: "-27px"}}>
              <Field
                component={FormCheckbox}
                name={name}
                onChange={(e, f, g, h) => {
                  changeFunc(f, h)

                }}

              />
            </FormControl>
            </GridItem>
  );
};


class BuySell extends React.Component {
  componentDidMount() 
  {


    this.props.state.businessOwners.map((e, i) => 
    {
      e.saleOnDeath.map((e, i) => 
      {
        e.standardPurchase = (e.ownerRef.ownership*1)/((100-((e.purchaseFrom.ownership*1) ))/100)
        e.customPurchase = (e.ownerRef.ownership*1)/((100-((e.purchaseFrom.ownership*1) ))/100)
      })
    })


    this.props.scrollMeBar();

      this.props.state.businessOwners.map((e, i) => 
      {
      var taxables = [
        {
          field: "businessOwners",      
          fieldName: "businessOwners.tax-",  
          fieldVar: "tax",   
          value: false,
          conditions:
          [
            {
              condition: "type", 
              param: "individual" ,    
              falseValue: true
            }
          ]
        }
      ]
      this.props.initializeDynamicField("taxablesInit", taxables);
    })
      
    var duties = [
        {
          field: "businessOwners",      
          fieldName: "businessOwners.taxAmount-",  
          fieldVar: "taxAmount",
          value: "20"
        }
      ]
      this.props.initializeDynamicField("dutiesInit", duties);
   
    console.log(this.props.state)
  }

  changeReason(name)
  {
    var reasons = this.props.fnaReasons;
    reasons[name] = !reasons[name];
    console.log(reasons)
    this.props.changePersonal("fnaReasons", reasons)

  }

 

  render()
  {
    var clientD = "";
   /* if(this.props.state.client)
      clientD = this.props.state.client.first_name + " " + this.props.state.client.surname*/
    return(
      <div className="contentWithStepper">
       
        <Card
        style={{ width: "120%", marginLeft:"-10%" }}
        >
          <CardContent>
            <CustomCardHeading
              subheading={"Business Needs Analysis"}
              caption={clientD}
              headline={"Buy and Sell"}
            />

         

          <h4>
            <b>Sale on death of:</b>
          </h4>


          {
            this.props.state.businessOwners.map((e, i) => 
            {
              var owner = e;
              var ownerI = i;
              if(e.isOwner)
                return(
                  <ExpansionPanel defaultExpanded={1 === 0} key={101}  >
        <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
        
        <Grid
  container
  direction="row"
  justifyContent="flex-end"
  alignItems="center"
>
          <GridItem xs={2} sm={2} md={2} style={{ marginTop: '25px' }}>
            <Typography style={{ fontSize: '21px' , fontWeight:"420"}}>
              {e.name}
          </Typography>
	        </GridItem>

          <GridItem xs={2} sm={2} md={2} style={{ marginTop: '25px' }}>
            <Typography style={{ fontSize: '16px' , fontWeight:"410"}}>
             Current Ownership{" "} {e.ownership}{"%"}
          </Typography>
	        </GridItem>

          <GridItem xs={2} sm={2} md={2} style={{ marginTop: '25px' }}>
            <Typography style={{ fontSize: '16px' , fontWeight:"410"}}>
             Going To Heirs{" "} {e.minusInheritance}{"%"}
          </Typography>
	        </GridItem>

          <GridItem xs={3} sm={3} md={3} style={{ marginTop: '25px' }}>
            <Typography style={{ fontSize: '16px' , fontWeight:"410"}}>
             Value to be sold{" "} R{((e.ownership/100 - (e.ownership * (e.minusInheritance/100))/100)*(this.props.state.marketValue*1)).toFixed(2)} 
          </Typography>
	        </GridItem>

          <GridItem xs={2} sm={2} md={2} style={{ marginTop: '25px' }}>
            <Typography style={{ fontSize: '16px' , fontWeight:"410"}}>
            Loan amount{" "} R{e.loan}
          </Typography>
	        </GridItem>
          <GridItem xs={12} sm={12} md={12} style={{ margin: '0px', padding: "0px" }}>
          <hr
style={{height: "1px", backgroundColor:"gray", borderColor:"gray"}}
/>
	        </GridItem>

        
        </Grid>

       
         
        
         
          </ExpansionPanelSummary>
          <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >

          
                  <Table className="customTable1" >
                    <TableHead className="fixedHead">
                    
                      <TableRow>

                     
                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("3em")}
                          colSpan={2}
                        >
                          <Typography style={{ fontSize: '16px',  }}></Typography>
                        </TableCell>
                      
                        

                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("3em")}
                          colSpan={2}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Existing</Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("3em")}
                          colSpan={2}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Nett Need</Typography>

                        </TableCell>


                      </TableRow>
                      <TableRow>

                      

                        

                        

                       

                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Estate Duty</Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>%</Typography>

                        </TableCell>

                        

                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Death</Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Disability</Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Death</Typography>

                        </TableCell>

                        <TableCell
                          className="cellPaddingTiny"
                          style={colwidth("6em")}
                        >
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>Disability</Typography>

                        </TableCell>

                        
                  
                      

                          
                    </TableRow>

                    </TableHead>
                    <TableBody>

                  
                      <TableRow>
                       
                       

                       

                        

                       

                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px", textAlign:"center" }}>
                         <Grid
                            container
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="center"
                          >
                            <GridItem xs={3} sm={3} md={3} style={{  }}></GridItem>
                            <GridItem xs={9} sm={9} md={9} style={{  }}>
                              {checkItem("", "businessOwners.tax-" + i, this.props.changeEstateDuty)}

                            </GridItem>
                        </Grid>
                        
                        </TableCell>

                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          {
                            this.props.state.businessOwners[i].tax === true &&
                            <CustomFieldN
                              
                              name={'businessOwners.taxAmount-' + i}
                              suffix="%"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'% Estate Duty'}
                              isrequired={false}
                              
                              onChange={(e, value, t, name) => this.props.changePersonal(value, name)}
                            />
                          }
                          
                        </TableCell>
                        
                       

                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <CustomFieldN
                              name={'businessOwners.deathExisting-' + i}
                              prefix="R"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'R'}
                              isrequired={true}
                              //validate={[required]}
                              onChange = {(e, f, g, h) => 
                                {
                                  this.props.changePersonal(f,h)
                                }}
                            />
                        </TableCell>

                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <CustomFieldN
                              name={'businessOwners.disabilityExisting-' + i}
                              prefix="R"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'R'}
                              isrequired={true}
                              //validate={[required]}
                              onChange = {(e, f, g, h) => 
                                {
                                  this.props.changePersonal(f,h)
                                }}
                            />
                        </TableCell>


                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>{((e.ownership/100 * this.props.state.marketValue)+(1*e.loan))/(1 - e.taxAmount/100) - e.deathExisting }</Typography>
                        </TableCell>

                        <TableCell style={{ padding: '5px', paddingTop:"27px", paddingBottom: "5px" }}>
                          <Typography style={{ fontSize: '16px', textAlign: "center" }}>{((e.ownership/100 * this.props.state.marketValue)+(1*e.loan)) - e.disabilityExisting  }</Typography>
                        </TableCell>
                        
                        
                      </TableRow>
                   
                     <TableRow>
                      <TableCell colSpan={6}>
                      <Grid container>
                    <GridItem xs={12} sm={12} md={12} style={{ margin: '0px', padding: "0px" }}>
          <hr
style={{height: "1px", backgroundColor:"gray", borderColor:"gray"}}
/>
	        </GridItem>
                  </Grid>
                      </TableCell>
                     </TableRow>

                    </TableBody>
                  </Table>
                  
                  
                  

               

         
               

              </ExpansionPanelDetails>
              <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
              <Grid container spacing={24} >
              {
                
    e.saleOnDeath.map((e, i) => 
    {
      
      {
        return(

          <ExpansionPanel defaultExpanded={1 === 0} key={111}  >
         <ExpansionPanelSummary  expandIcon={<Icon>expand_more</Icon>} >
           <Grid container spacing={24} >
            <GridItem xs={2} sm={2} md={2} style={{ marginTop: '25px' }}>
              <Typography style={{ fontSize: '16px' , fontWeight:"410"}}>
              <h5>
                Purchaser: {" "} {e.ownerRef.name}
              </h5>
              </Typography>
            </GridItem>
            

            <GridItem xs={2} sm={2} md={2} style={{ marginTop: '25px' }}>
            <Typography style={{ fontSize: '16px' , fontWeight:"410"}}>
              Current Ownership: {" "} {e.ownerRef.ownership}%
          </Typography>
	        </GridItem>
          <GridItem xs={2} sm={2} md={2} style={{ marginTop: '25px' }}>
            <Typography style={{ fontSize: '16px' , fontWeight:"410"}}>
              Traditionally Bought: {" "} {e.standardPurchase.toFixed(2)}%
          </Typography>
	        </GridItem>

          <GridItem xs={2} sm={2} md={2} style={{ marginTop: '25px' }}>
            <Typography style={{ fontSize: '16px' , fontWeight:"410"}}>
              Position After Sale: {" "} {((e.customPurchase/100 * (e.purchaseFrom.ownership*1 - (e.purchaseFrom.minusInheritance/100 * e.purchaseFrom.ownership*1))) + e.ownerRef.ownership*1).toFixed(2)}%
          </Typography>
	        </GridItem>

          <GridItem xs={12} sm={12} md={12} style={{ margin: '0px', padding: "0px" }}>
              <hr style={{height: "1px", backgroundColor:"gray", borderColor:"gray"}} />
            </GridItem>
            </Grid>
            </ExpansionPanelSummary>

            <ExpansionPanelDetails  onClick={(event) => { event.stopPropagation()}} >
            <Grid container spacing={24} >
            <GridItem xs={4} sm={4} md={4} style={{ margin: '0px', padding: "0px" }}>
              <CustomFieldN
                              name={'businessOwners.saleOnDeath.customPurchase-' + ownerI + "-" + i}
                              suffix="%"
                              component={NumberInput}
                              checkValidation={this.props.checkValidation}
                              label={'Bought %'}
                              isrequired={true}
                              //validate={[required]}
                              onChange = {(e, f, g, h) => 
                                {
                                  this.props.changePersonal(f,h)
                                }}
                            />
            </GridItem>

            


            <GridItem xs={12} sm={12} md={12} style={{ marginTop: '25px' }}>
            <Table className="customTable1">
            <TableHead className="fixedHead">
            
              <TableRow>
              
            

                

              </TableRow>
             

            </TableHead>
            <TableBody>

           
             

            </TableBody>
          </Table>
            </GridItem>
          

          

        </Grid>
        </ExpansionPanelDetails>
         </ExpansionPanel>
        )
      }
    })
  }
  </Grid>
              </ExpansionPanelDetails>
            </ExpansionPanel>
                )
            })
          }



          


           
          </CardContent>
        </Card>

       

      </div>

    );
  }
}

export default BuySell;



// WEBPACK FOOTER //
// ./src/views/Bna/steps/BuySell.jsx